// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var Jspdf = require('jspdf');
var DomToImage = require('dom-to-image');
;

function generatePdf(_element) {
  return (DomToImage.toPng(_element).then(function(dataUrl) {
    var htmlImage = new Image();
    htmlImage.src = dataUrl;
    var jsPdf = new Jspdf.jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: [500, 1000]
    });
    jsPdf.addImage(htmlImage, 'JPEG', 0, 0, 500, 1000);
    jsPdf.save('download.pdf');
    return Promise.resolve();
  }));
}

function generateDashboardPdf(_element) {
  return (DomToImage.toPng(_element, {filter: function(node) {
  return node.tagName !== 'BUTTON';}}).then(function(dataUrl) {
    var htmlImage = new Image();
    htmlImage.src = dataUrl;
    var jsPdf = new Jspdf.jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: [1000, 1000]
    });
    jsPdf.addImage(htmlImage, 'JPEG', 0, 0, 1000, 1000);
    jsPdf.save('download.pdf');
    return Promise.resolve();
  }));
}

function generateEnlargedChartsPdf(_selector) {
  return ((function() {
    var waitForChartPages = function(selector, maxAttempts, intervalMs) {
      return new Promise(function(resolve, reject) {
        var attempts = 0;
        var poll = function() {
          attempts += 1;
          var pages = Array.from(document.querySelectorAll(selector));
          if (pages.length === 0) {
            if (attempts >= maxAttempts) {
              reject(new Error('No exportable chart pages found'));
              return;
            }
            setTimeout(poll, intervalMs);
            return;
          }

          var loadingExists = pages.some(function(page) {
            return page.querySelector('.loading-animation') !== null;
          });

          if (!loadingExists) {
            resolve(pages);
            return;
          }

          if (attempts >= maxAttempts) {
            reject(new Error('Export timed out while waiting for charts to render'));
            return;
          }

          setTimeout(poll, intervalMs);
        };

        poll();
      });
    };

    var captureWithRetry = function(element, retries) {
      return DomToImage.toJpeg(element, {
        quality: 0.85,
        bgcolor: '#ffffff',
        cacheBust: true,
        imagePlaceholder: '',
        filter: function(node) {
          if (!node || !node.tagName) {
            return true;
          }
          var classes = node.classList || [];
          var shouldExclude = classes.contains && (
            classes.contains('pdf-exclude') ||
            classes.contains('disabled-wrapper')
          );
          return node.tagName !== 'BUTTON' && !shouldExclude;
        }
      }).catch(function(error) {
        if (retries <= 0) {
          return Promise.reject(error);
        }
        return new Promise(function(resolve) {
          setTimeout(resolve, 500);
        }).then(function() {
          return captureWithRetry(element, retries - 1);
        });
      });
    };

    return waitForChartPages(_selector, 240, 500).then(function(pages) {
      var jsPdf = new Jspdf.jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: 'a4'
      });

      var margin = 24;
      var pageWidth = jsPdf.internal.pageSize.getWidth();
      var pageHeight = jsPdf.internal.pageSize.getHeight();
      var maxWidth = pageWidth - margin * 2;
      var maxHeight = pageHeight - margin * 2;

      var exportPage = function(index) {
        if (index >= pages.length) {
          jsPdf.save('dashboard-enlarged-charts.pdf');
          return Promise.resolve();
        }

        var pageElement = pages[index];
        return captureWithRetry(pageElement, 1).then(function(dataUrl) {
          var imageProperties = jsPdf.getImageProperties(dataUrl);
          var widthRatio = maxWidth / imageProperties.width;
          var heightRatio = maxHeight / imageProperties.height;
          var scale = Math.min(widthRatio, heightRatio);
          var renderWidth = imageProperties.width * scale;
          var renderHeight = imageProperties.height * scale;
          var x = (pageWidth - renderWidth) / 2;
          var y = (pageHeight - renderHeight) / 2;

          jsPdf.addImage(dataUrl, 'JPEG', x, y, renderWidth, renderHeight);
          if (index < pages.length - 1) {
            jsPdf.addPage();
          }
          return exportPage(index + 1);
        });
      };

      return exportPage(0);
    });
  })());
}

exports.generatePdf = generatePdf;
exports.generateDashboardPdf = generateDashboardPdf;
exports.generateEnlargedChartsPdf = generateEnlargedChartsPdf;
/*  Not a pure module */
